export default __webpack_public_path__ + "static/media/SlopeParameterFormula.46dcc492.png";